import React, { useState } from 'react';
import DangerButton from './DangerButton';
import DialogModal from './DialogModal';
import SecondaryButton from './SecondaryButton';

export default function DeletePromotion({id, deleteRow}) {
    const [open, setOpen] = useState(false);

    const deleteOffer = () => {
        setOpen(false)
        deleteRow(id);
    }

    return (
        <div>
            <DangerButton onClick={() => setOpen(true)}>Delete</DangerButton>
            <DialogModal openModal={open} setOpenModal={setOpen}> 
                <DialogModal.Content title={'Delete Promotion'}>
                    Are you sure you wish to delete this promotion?
                </DialogModal.Content>
                <DialogModal.Footer>
                    <SecondaryButton onClick={() => setOpen(false)}>No</SecondaryButton>
                    <DangerButton
                        onClick={() => deleteOffer(id)}
                    >
                        Yes
                    </DangerButton>
                </DialogModal.Footer>
            </DialogModal>
        </div>
    );
}
